import { Button, Input } from "@nextui-org/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { resetPassword, sendPasswordResetEmailLink } from "../../redux/actions/authActions";

const Recovery = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const handleOnResetPassword = async () => {
    if (!email) return;
    await dispatch(sendPasswordResetEmailLink(email));
    navigate("/login");
  };

  return (
    <div className="w-full flex flex-col items-start font-PlusJakartaSans">
      <h2 className="w-full text-2xl font-semibold text-gray-700">{t("Reset your password")}</h2>
      <p className="w-full text-sm text-gray-400/70 mt-1 mb-10 font-normal">
        {t("Enter your email and we will send you your new password.")}
      </p>
      <Input
        placeholder="mail@simmmple.com"
        label={t("Email")}
        labelPlacement="outside"
        value={email}
        isRequired
        variant="bordered"
        color="primary"
        onChange={(e) => setEmail(e.target.value)}
        className="max-w-xs mb-6"
        classNames={{
          label: "text-sm text-gray-700 font-medium",
          inputWrapper: "border-1 border-gray-400",
          input: "placeholder:text-gray-300 placeholder:text-xs",
        }}
      />
      <Button
        color="primary"
        className="w-full max-w-xs h-12 mt-4"
        onClick={handleOnResetPassword}
      >
        {t("Reset My Password")}
      </Button>
      <Button
        variant="danger"
        color="default"
        className="w-full max-w-xs"
        onPress={() => navigate("/login")}
      >
        {t("Cancel")}
      </Button>
    </div>
  );
};

export default Recovery;
